'use client';


import type { ReactNode } from 'react';
import { motion, useInView } from 'framer-motion';
import { getCdnUrl } from '@/utils/cdn';
import { useRef } from 'react';

type Feature = { label: string; icon: ReactNode };

const FEATURES: Feature[] = [
	{
		label: 'Áreas de lazer',
		icon: (
			<svg
				preserveAspectRatio="xMidYMid meet"
				viewBox="24 24 152 152"
				height="22"
				width="22"
				xmlns="http://www.w3.org/2000/svg"
				className="text-[#E0D9CE]" // aqui você controla a cor
			>
				<g>
					<path
						d="M82.301 24c18.758 0 32.934 16.829 32.934 34.2s-17.885 23.886-12.76 30.943c5.017 6.84 27.264 7.057 39.805 1.303s10.033-15.417 15.486-17.914c5.998-2.171 28.354 29.314 12.869 63.514C152.64 174.697 115.561 176 89.934 176c-42.749-.869-63.252-23.886-63.252-49.943 0-29.531 25.083-33.114 25.083-40.714.218-5.429-23.993-10.64-27.482-25.84-1.636-8.686 4.362-9.229 4.362-9.229s14.395 2.714 18.758-1.629C54.273 43.543 50.129 24 82.301 24z"
						fill="currentColor"
					/>
				</g>
			</svg>
		),
	},
	{
		label: 'Metragem ideal',
		icon: (
			<svg
				preserveAspectRatio="xMidYMid meet"
				className="text-[#E0D9CE]"
				viewBox="19.999 20 160.002 160"
				height="22"
				width="22"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path d="M180.001 180H19.999V20l160.002 160z" fill="currentColor" />
			</svg>

		),
	},
	{
		label: 'Espaço Gourmet',
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="19.999 32.001 160.001 135.998"
				width="22"
				height="22"
				preserveAspectRatio="xMidYMid meet"
				className="text-[#F0F0F0]" // ⬅️ controla a cor aqui
			>
				<g>
					<path fill="currentColor" d="M167.464 65.395c.82-.037 1.272-.005 1.704-.085 2.538-.467 5.044-1.162 7.661-1.039.702.033 1.417.035 2.099.178.409.086.766.418 1.072.597-.005.869-.594 1.156-1.012 1.529-2.647 2.36-4.188 5.324-4.878 8.764-.207 1.035-.393 2.074-.612 3.107a50.276 50.276 0 01-.64 2.737c-.297 1.093-.922 1.938-2.121 2.077-1.234.144-1.959-.694-2.497-1.625-.585-1.012-1.119-2.068-1.536-3.159-.544-1.422-.946-2.897-1.417-4.347-.32-.984-.4-2.068-1.145-2.865-.973-.101-1.522.605-2.169 1.071-2.971 2.139-6.256 3.127-9.932 2.951a14.139 14.139 0 01-5.423-1.365c-.848-.4-1.67-.859-2.482-1.33-7.801-4.525-16.167-7.506-25.026-9.126-1.732-.316-3.484-.531-5.234-.733-1.642-.19-2.491.076-1.995 2.067.737 2.957 1.304 5.959 1.842 8.96.414 2.308.875 4.637.96 6.97.176 4.851-1.483 8.979-5.483 11.97-.562.42-1.177.778-1.798 1.107-1.189.63-1.588 1.627-1.543 2.916.09 2.582.132 5.166.202 7.75.14 5.165.293 10.331.425 15.496.312 12.211.607 24.423.93 36.633.065 2.465.275 4.926.329 7.39.045 2.089-.687 3.04-2.64 3.575-2.21.605-4.422.634-6.566-.284-1.032-.442-1.76-1.165-1.735-2.403.007-.352-.019-.705-.011-1.057.157-6.457.322-12.915.473-19.372.132-5.637.238-11.274.377-16.91.233-9.393.483-18.786.725-28.178.012-.47.018-.94.026-1.409.054-3.336-.006-3.095-2.503-4.326-4.003-1.974-6.092-5.296-6.874-9.629-.6-3.323-.073-6.555.463-9.789.422-2.543 1.047-5.052 1.566-7.58.118-.573.183-1.157.251-1.739.055-.477-.353-.968-.812-.93-.931.076-1.874.129-2.786.317-8.894 1.831-17.431 4.751-25.678 8.526-2.455 1.124-4.901 2.284-7.27 3.575-3.347 1.824-6.863 2.268-10.581 1.742-1.545-.218-2.924-.839-4.306-1.489-.318-.15-.634-.305-.959-.439-.42-.173-1.048.096-1.133.525-.182.915-.279 1.848-.479 2.759-.376 1.714-.748 3.432-1.232 5.116-.185.644-.674 1.201-1.076 1.884-.376-.218-.801-.312-.906-.548-2.023-4.55-5.567-7.459-10.015-9.447-.958-.428-1.865-1.002-2.722-1.612-.459-.327-.817-.838-1.12-1.328-.481-.779-.146-2.021.634-2.489 1.126-.674 2.348-1.084 3.666-1.117 1.998-.051 3.997-.056 5.995-.097.69-.014 1.42.152 2.039-.35.469-.804.124-1.607-.097-2.364-1.736-5.968.907-13.652 7.771-17.229 13.292-6.927 27.103-12.405 41.86-15.344 5.422-1.08 10.862-1.949 16.397-2.152 2.582-.095 5.164-.435 7.742-.395 19.186.298 37.135 5.091 53.701 14.872 3.708 2.189 6.303 5.193 7.517 9.369.537 1.849.507 3.715.419 5.59-.047 1.043-.229 2.081-.402 3.56zm-64.969-2.425c-.059.372-.199.719-.154 1.042a2988.06 2988.06 0 002.112 14.915c.033.228.107.46.211.665.39.766.941 1.338 1.865 1.39.739.042 1.625-.556 1.88-1.33.181-.548.358-1.128.369-1.697.084-4.559.129-9.119.184-13.678.001-.117-.01-.234-.02-.35-.067-.8-.538-1.363-1.284-1.38a71.932 71.932 0 00-4.206.028c-.318.011-.628.253-.957.395zm-8.698.582c-.064.971-.154 1.659-.148 2.346.034 3.733.089 7.465.146 11.198.009.582.002 1.176.116 1.742.088.442.3.882.546 1.266.749 1.172 2.532 1.18 3.215-.027.331-.586.509-1.294.608-1.968.647-4.381 1.255-8.767 1.871-13.152.049-.346.079-.695.1-1.043.035-.575-.466-1.139-1.036-1.193-1.779-.17-3.456.276-5.418.831zm9.493-6.492c.902-.39 1-1.147 1.179-1.794 2.198-7.926 6.939-13.715 14.39-17.279.566-.271 1.404-.366 1.487-1.257.047-.503-.758-.718-2.163-.486-1.152.19-2.325.365-3.428.728-7.002 2.305-11.848 8.689-12.247 16.071-.075 1.399.099 2.755.782 4.017zm-20.938.78c.106-.07.269-.116.293-.201.285-1.012.576-2.024.814-3.048 1.552-6.671 5.001-12.066 10.71-15.948.679-.462 1.399-.867 2.045-1.369.341-.264.622-.648.823-1.034.156-.3-.642-.581-1.465-.47-.463.062-.933.117-1.382.241-7.15 1.972-11.815 7.474-13.018 14.636-.31 1.848-.318 3.75.136 5.592.149.605.185 1.41 1.044 1.601zm63.336-15.834c-1.851-.763-3.204-1.058-4.523-1.024-7.696.199-14.571 5.491-16.675 12.924-.313 1.105-.294 2.306-.383 3.467-.013.17.196.454.363.512.163.056.498-.047.593-.19.584-.877 1.115-1.789 1.676-2.682 3.656-5.815 8.723-9.763 15.392-11.582.792-.216 1.614-.339 2.387-.606.399-.138.723-.497 1.17-.819zm-69.551-1.604c-1.169-.757-1.967-.45-2.717-.167-6.057 2.287-9.845 6.64-11.258 12.902-.699 3.098-.67 6.286.551 9.327.164.408.507.76.825 1.08.076.076.546-.049.565-.139a14.51 14.51 0 00.308-2.05c.488-7.478 3.377-13.78 9.12-18.698.789-.675 1.571-1.359 2.606-2.255z" data-color="1"></path>

				</g>
			</svg>
		),
	},
	{
		label: 'Portaria 24h',
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="33.5 20 133 160.001"
				width="22"
				height="22"
				preserveAspectRatio="xMidYMid meet"
				className="text-[#F0F0F0]" // ⬅️ define a cor
			>
				<g>
					<path
						d="M161.332 41.97c-9.542 0-38.568-3.701-57.654-20.705-1.789-1.6-4.572-1.7-6.561-.2C73.659 39.27 50.399 41.97 38.669 41.97c-2.883 0-5.169 2.3-5.169 5.201 0 30.807 5.666 74.316 32.902 106.523 16.501 19.705 33.201 25.706 33.897 26.006.497.2 1.094.301 1.689.301.796 0 1.491-.1 2.187-.5.597-.301 16.203-7.602 31.61-27.706 6.823-8.911 14.278-21.32 20.137-37.846.057-.151.107-.306.163-.457 6.09-17.348 10.415-39.202 10.415-66.319.001-2.903-2.285-5.203-5.168-5.203z"
						fill="currentColor"
					/>
				</g>
			</svg>
		),
	},
	{
		label: 'Piscinas de borda infinita',
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="13.757 59.017 173.096 85.266"
				width="22"
				height="22"
				preserveAspectRatio="xMidYMid meet"
				className="text-[#F0F0F0]" // ⬅️ muda a cor facilmente
			>
				<g>
					<path
						d="m74.037 59.017 26.268 26.268 26.268-26.268 26.267 26.268 25.527-25.528 8.486 8.486-34.013 34.012-26.267-26.267-26.268 26.267-26.268-26.267-26.267 26.267-34.013-34.012 8.486-8.486L47.77 85.285l26.267-26.268Z"
						fill="currentColor"
						clipRule="evenodd"
						fillRule="evenodd"
					/>
					<path
						d="m74.038 101.045 26.267 26.268 26.268-26.268 26.268 26.268 25.527-25.528 8.485 8.486-34.012 34.012-26.268-26.267-26.268 26.267-26.267-26.267-26.268 26.267-34.012-34.012 8.485-8.486 25.527 25.528 26.268-26.268Z"
						fill="currentColor"
						clipRule="evenodd"
						fillRule="evenodd"
					/>
				</g>
			</svg>
		),
	},
];

export default function ComfortSection() {
	const textRef = useRef(null);
	const pillsRef = useRef(null);
	const textInView = useInView(textRef, { once: true, margin: '-100px' });
	const pillsInView = useInView(pillsRef, { once: true, margin: '-100px' });

	const variants = {
		hidden: { opacity: 0, y: 50 },
		visible: { opacity: 1, y: 0 },
	};

	return (
		<div className="bg-white md:px-12 px-5 md:py-20 py-12 z-20 relative">
			<div className="md:rounded-3xl">
				{/* Placa verde limitada à largura do container (mesma da imagem) */}
				<div ref={textRef} className="bg-[#dff8df] md:rounded-t-4xl rounded-t-xl text-center py-10  sm:py-10 md:py-20">
					<motion.h3
						variants={variants}
						initial="hidden"
						animate={textInView ? 'visible' : 'hidden'}
						transition={{ duration: 0.5, delay: 0.2 }}
						className="text-2xl md:text-6xl mx-auto w-[60%] text-[#1e293b]"
					>
						Espaços pensados para o seu bem-estar
					</motion.h3>
					<motion.p
						variants={variants}
						initial="hidden"
						animate={textInView ? 'visible' : 'hidden'}
						transition={{ duration: 0.5, delay: 0.4 }}
						className="mt-5 text-[#475569] font-light md:w-[50%] w-[73%] mx-auto md:pb-0 pb-8 text-start md:text-center text-md sm:text-lg"
					>
						Plantas inteligentes, áreas de lazer completas e acabamentos de alta qualidade para você viver com conforto e praticidade.
					</motion.p>
				</div>

				{/* Imagem com pills sobrepostos, logo abaixo da placa verde */}
				<div className="relative -mt-6 rounded-4xl shadow-lg">
					<img src={getCdnUrl("/images/pg.avif")} alt="Lazer" width={1600} height={900} className="w-full object-cover h-[80vh] md:rounded-b-4xl rounded-b-xl md:h-[75vh]" />

					{/* Pills sobre a imagem */}
					<div ref={pillsRef} className="absolute z-10 left-1/2 -translate-x-1/2 md:bottom-12 bottom-2 grid grid-cols-3 lg:grid-cols-5 gap-2 sm:gap-12 w-[98%] px-4  ">
						{FEATURES.map(({ label, icon }, index) => (
							<motion.div
								key={label}
								variants={variants}
								initial="hidden"
								animate={pillsInView ? 'visible' : 'hidden'}
								transition={{ duration: 0.5, delay: index * 0.2 }}
								className="bg-[#54d454] text-white rounded-2xl md:p-6 p-3 flex items-center justify-center shadow-xl"
							>
								<div className="flex flex-col items-center gap-1 sm:gap-2">
									{icon}
									<span className=" text-center text-xs sm:text-sm">{label}</span>
								</div>
							</motion.div>
						))}
					</div>
				</div>
			</div>
		</div>

	);
}